import { CatalogTransferView } from '@Entities/rightsholder/catalog-transfer-view'

const TRANSFER_TYPE = {
    ACQUISITION: 'ACQUISITION',
    RELINQUISHMENT: 'RELINQUISHMENT',
}

export const getMyPublisher = (transfer: CatalogTransferView) =>
    transfer.catalogTransferType === TRANSFER_TYPE.ACQUISITION
        ? transfer.targetPublisher
        : transfer.sourcePublishers?.[0]
export const getTheirPublisher = (transfer: CatalogTransferView) =>
    transfer.catalogTransferType === TRANSFER_TYPE.ACQUISITION
        ? transfer.sourcePublishers?.[0]
        : transfer.targetPublisher

export const getDateHeader = (transfer: CatalogTransferView) =>
    transfer.submittedAt ? 'Submitted' : 'Last modified date'
export const getDateValue = (transfer: CatalogTransferView) =>
    transfer.submittedAt
        ? new Date(transfer.submittedAt).toLocaleDateString()
        : new Date(transfer.updatedAt).toLocaleDateString()
